import type { IMetaDataFormHook } from '../../../app/electoral-divisions/lga/utils';
import type { ILGAByIDState, ILGAByName, ILGAInStates } from '../../../interface/state/ILGAState';
import { lgaType } from '../../types';
import { createAPI, deleteByIdAPI, getAPI, getByIdAPI, getByNameAPI, getFetchAPI, updateAPI, updateByIdAPI } from '../api-utils';

export const create = createAPI<undefined, ICreateUpdateLGA>({
	actionType: lgaType.create,
	url: '/api/v1/LGA',
});

export const get = getAPI({
	actionType: lgaType.get,
	url: '/api/v1/LGA',
	type: 'core',
});

export const getById = getByIdAPI<ILGAByIDState>({
	actionType: lgaType.getById,
	url: '/api/v1/LGA',
});

export const getByName = getByNameAPI<ILGAByName>({
	actionType: lgaType.getByName,
	url: '/api/v1/LGA/name',
});

export const getByCode = getFetchAPI<ILGAByIDState, { code: string }>({
	actionType: lgaType.getByCode,
	url: '/api/v1/LGA/code',
});

export const getInState = getFetchAPI<ILGAInStates, { stateIds: number[] }>({
	actionType: lgaType.getInState,
	url: '/api/v1/LGA/getLgasInState',
});

export interface ICreateUpdateLGA {
	id?: number;
	wardCount: number;
	constituencyCount: number;
	pollingUnitCount: number;
	name: string;
	lgaCode: string;
	stateId: number;
}

export const update = updateAPI<undefined, ICreateUpdateLGA>({
	actionType: lgaType.update,
	url: '/api/v1/LGA/update',
});

export const deleteById = deleteByIdAPI({
	actionType: lgaType.deleteById,
	url: '/api/v1/LGA/delete',
});

export const updateMetaData = updateByIdAPI<undefined, IMetaDataFormHook>({
	actionType: lgaType.updateMetaData,
	url: '/api/v1/LGA/updatemetadata',
});
